// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { oasisTestnet as _oasisTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the oasisTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 4090
 * Chain Name: Oasis Testnet
 * Default Block Explorer: https://oasis.ftnscan.com
 * Default RPC URL: https://rpc1.oasis.bahamutchain.com
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { oasisTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: oasisTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const oasisTestnet = createCommon({
	..._oasisTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
